module.exports = __webpack_public_path__ + "img/qr-nequi.ba342d0e.png";